<template>
    <div class="home-service">
        <img class="home-service-backimg" :src="backImg" alt="">
        <div class="home-service-box">
            <p class="home-service-title">
                更多服务
            </p>
            <p class="home-service-normal">
                保时达为客户以及车队双方提供相应保障服务的承诺
            </p>

            <div class="home-service-row">
                <div class="home-service-row-list" v-for="(item, index) in serviceList" :key="index">
                    <div class="service-row-box">
                        <img class="service-row-icon" :src="item.iconUrl" alt="">
                    </div>
                    <div class="service-row-span">
                        <div class="service-row-span-top">
                            {{ item.title }}
                        </div>
                        <div class="service-row-span-bottom">
                            {{ item.detail }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "homeService",
        data() {
            return {
                backImg: require('@/assets/images/index/public_img_serviceBg.png'),
                serviceList: [
                    {
                        iconUrl: require('@/assets/images/index/home_img_service01.png'),
                        title: '7*24小时在线客服',
                        detail: '随时待命，提供服务与支援'
                    },
                    {
                        iconUrl: require('@/assets/images/index/home_img_service02.png'),
                        title: '证件齐价格透明',
                        detail: '品质保证，让您一路安心出行'
                    },
                    {
                        iconUrl: require('@/assets/images/index/home_img_service03.png'),
                        title: '理赔一对一',
                        detail: '专业保险，全程陪伴'
                    }
                ]
            }
        },
    }
</script>

<style scoped>
    .home-service {
        width: 100%;
        height: 480px;
        min-width: 1200px;
        position: relative;
    }

    .home-service-backimg {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -1;
    }

    .home-service-box {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        padding-top: 42px;
    }

    .home-service-title {
        width: 500px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        color: #333;
        font-size: 32px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin: 0 auto;
    }

    .home-service-normal {
        width: 500px;
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        margin: 12px auto 0;
        text-align: center;
    }

    .home-service-row {
        width: 1200px;
        margin: 40px auto 0;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .home-service-row-list {
        width: 385px;
        height: 260px;
        position: relative;
        margin-right: 25px;
    }

    .home-service-row-list:nth-child(3) {
        margin-right: 0;
    }

    .service-row-box {
        width: 385px;
        height: 260px;
    }

    .service-row-icon {
        width: 100%;
        height: 100%;
    }

    .service-row-span {
        position: absolute;
        bottom: 18px;
        left: 26px;
        z-index: 2;
    }

    .service-row-span-top {
        height: 30px;
        line-height: 30px;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
    }

    .service-row-span-bottom {
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
    }
</style>



// WEBPACK FOOTER //
// src/pages/home/components/homeService.vue